import { render } from "./App.vue?vue&type=template&id=5c741e5e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5c741e5e&lang=css"

import exportComponent from "C:\\git\\Source\\Repos\\LDI.ApplicationSupport.ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__